export default company => company?.phone;
